import { EnumerationDisplayType } from 'customer-data-filters-ui/filterQueryFormat/DisplayTypes';
import { GOTO_WEBINAR_WEBINAR } from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { __ANY_WEBINAR } from '../ListSegConstants';
import DSFieldRecord from 'customer-data-filters-ui/filterQueryFormat/DSFieldRecord/DSFieldRecord';
import once from 'transmute/once';
import unescapedText from 'I18n/utils/unescapedText';
export default once(() => DSFieldRecord({
  displayType: EnumerationDisplayType,
  label: unescapedText('customerDataFiltersUI.customerDataFilters.FilterEditor.specialOptionValues.anyWebinar'),
  name: __ANY_WEBINAR,
  type: GOTO_WEBINAR_WEBINAR
}));